import { Link } from "react-router-dom";
import { API, fmtDate, inr, todayISO } from "@/lib/api";
import { Panel, StatusBadge } from "@/components/admin/common";

const Block = ({ title, count, children, testId }) => (
  <div data-testid={testId}>
    <p className="text-sm font-semibold text-navy">{title} <span className="font-mono text-slate-400">({count})</span></p>
    <div className="mt-2 divide-y divide-slate-100 rounded-xl border border-slate-200">{count === 0 ? <p className="p-3 text-xs text-slate-400">None yet</p> : children}</div>
  </div>
);

export const LeadHistory = ({ h }) => (
  <Panel className="p-5 space-y-5" data-testid="lead-history">
    <p className="font-semibold text-navy">Enquiry history, quotations & bookings</p>
    <Block title="Other enquiries from this number" count={h.related.length} testId="lead-history-related">
      {h.related.map((e) => (
        <Link key={e.id} to={`/admin/leads/${e.id}`} className="flex items-center justify-between gap-3 p-3 hover:bg-slate-50" data-testid={`lead-history-related-${e.id}`}>
          <div className="min-w-0"><p className="text-sm text-navy truncate">{e.package_name || e.trip_type || "General enquiry"}</p><p className="text-xs text-slate-500">Received {fmtDate(e.created_at)} · Travel {fmtDate(e.travel_date)}</p></div>
          <StatusBadge status={e.status} />
        </Link>
      ))}
    </Block>
    <Block title="Quotations" count={h.quotes.length} testId="lead-history-quotes">
      {h.quotes.map((q) => (
        <div key={q.id} className="flex items-center justify-between gap-3 p-3">
          <div className="min-w-0"><p className="text-sm text-navy truncate"><span className="font-mono text-ocean">{q.quote_no}</span> · {q.package_name}</p>
            <p className="text-xs text-slate-500">{inr(q.grand_total)} · {fmtDate(q.created_at)} · {q.valid_until?.slice(0, 10) < todayISO() ? "Expired" : `Valid till ${fmtDate(q.valid_until)}`}</p></div>
          <a href={`${API}/admin/quotes/${q.id}/pdf`} target="_blank" rel="noreferrer" className="text-xs font-semibold text-ocean shrink-0" data-testid={`lead-history-quote-pdf-${q.id}`}>PDF</a>
        </div>
      ))}
    </Block>
    <Block title="Bookings" count={h.bookings.length} testId="lead-history-bookings">
      {h.bookings.map((b) => (
        <Link key={b.id} to="/admin/bookings" className="flex items-center justify-between gap-3 p-3 hover:bg-slate-50">
          <div className="min-w-0"><p className="text-sm text-navy truncate"><span className="font-mono text-ocean">{b.booking_no}</span> · {b.package_name}</p>
            <p className="text-xs text-slate-500">Travel {fmtDate(b.travel_date)} · {inr(b.total_price)} · Balance {inr(b.balance_due)}</p></div>
          <StatusBadge status={b.status} kind="booking" />
        </Link>
      ))}
    </Block>
  </Panel>
);
